// // src/components/AuthModal.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext.jsx";
// import OtpInputs from "../components/OtpInputs.jsx";
// import { sendOtp, verifyOtp, registerUser } from "../api/auth.js";
// import { toast } from "react-toastify";

// /* -----------------------------------------------------------
//    Shell: accessible modal with backdrop + scale/opacity anim
// ----------------------------------------------------------- */
// function ModalShell({ open, onClose, children, title = "Account" }) {
//   useEffect(() => {
//     const onEsc = (e) => e.key === "Escape" && onClose?.();
//     document.addEventListener("keydown", onEsc);
//     return () => document.removeEventListener("keydown", onEsc);
//   }, [onClose]);

//   return (
//     <div
//       aria-hidden={!open}
//       className={`fixed inset-0 z-[100] ${open ? "" : "pointer-events-none"}`}
//     >
//       {/* Backdrop */}
//       <div
//         className={`absolute inset-0 bg-black/50 transition-opacity ${open ? "opacity-100" : "opacity-0"}`}
//         onClick={onClose}
//       />
//       {/* Dialog */}
//       <div
//         role="dialog"
//         aria-modal="true"
//         aria-label={title}
//         className={`absolute left-1/2 top-1/2 w-[92vw] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-amber-100/70 bg-white/95 backdrop-blur shadow-2xl transition-all ${
//           open ? "opacity-100 scale-100" : "opacity-0 scale-95"
//         }`}
//       >
//         {children}
//       </div>
//     </div>
//   );
// }

// /* -----------------------------------------------------------
//    Small UI atoms
// ----------------------------------------------------------- */
// function FieldLabel({ children }) {
//   return <label className="text-xs font-semibold text-slate-600">{children}</label>;
// }
// function HelpText({ children }) {
//   return <p className="mt-1 text-xs text-slate-500">{children}</p>;
// }
// function ErrorText({ children }) {
//   return <p className="mt-1 text-xs text-rose-600">{children}</p>;
// }
// function SolidButton({ disabled, children, onClick }) {
//   return (
//     <button
//       disabled={disabled}
//       onClick={onClick}
//       className={`mt-4 w-full rounded-full px-5 py-2.5 font-semibold transition-all
//         ${disabled
//           ? "bg-slate-200 text-slate-500 cursor-not-allowed"
//           : "bg-gradient-to-r from-amber-400 to-amber-500 text-slate-900 hover:from-amber-500 hover:to-amber-600 shadow-sm"
//         }`}
//     >
//       {children}
//     </button>
//   );
// }

// /* -----------------------------------------------------------
//    Phone input with +91 lock, validation highlight
// ----------------------------------------------------------- */
// function PhoneInput({ value, onChange, disabled, invalid }) {
//   return (
//     <div className="mt-1 flex">
//       <span className="inline-flex items-center rounded-l-lg border border-r-0 px-3 text-slate-600 bg-slate-50">
//         +91
//       </span>
//       <input
//         className={`flex-1 rounded-r-lg border px-3 py-2 outline-none focus:ring-2 ${invalid ? "border-rose-300 focus:ring-rose-200" : "focus:ring-amber-300"}`}
//         placeholder="10-digit number"
//         value={value}
//         disabled={disabled}
//         inputMode="numeric"
//         autoComplete="tel"
//         onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 10))}
//       />
//     </div>
//   );
// }

// /* ======================== LOGIN (OTP) ======================== */
// function LoginForm({ next, onDone }) {
//   const nav = useNavigate();
//   const { login } = useAuth();

//   const [phone, setPhone] = useState("");
//   const [step, setStep] = useState("details"); // details | otp
//   const [otp, setOtp] = useState("");
//   const [timer, setTimer] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const validPhone = isValidIndianPhoneInput(phone);

//   useEffect(() => {
//     if (timer <= 0) return;
//     const t = setTimeout(() => setTimer((s) => s - 1), 1000);
//     return () => clearTimeout(t);
//   }, [timer]);

//   const send = async () => {
//     try {
//       setLoading(true);
//       await sendOtp(phone);
//       setStep("otp");
//       setTimer(30);
//       toast.success("OTP sent successfully ✅");
//     } catch (e) {
//       toast.error(e?.message || "Failed to send OTP ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const verify = async () => {
//     try {
//       setLoading(true);
//       const resp = await verifyOtp({ mobile: phone, code: otp });
//       const token = resp?.token || resp?.jwt || "demo_jwt_" + Date.now();
//       const profile = resp?.data || resp?.profile || resp;
//       const finalUser = {
//         id: profile?._id ?? phone,
//         name: profile?.name ?? ("User " + phone.slice(-4)),
//         phone: profile?.mobile ?? phone,
//         role: profile?.role,
//         avatar: profile?.profileImage,
//         email: profile?.email,
//       };
//       login(finalUser, token);
//       toast.success("Logged in successfully 🎉");
//       onDone?.();
//       nav(next || "/", { replace: true });
//     } catch (e) {
//       toast.error(e?.message || "OTP verification failed ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       {step === "details" ? (
//         <>
//           <FieldLabel>Mobile Number</FieldLabel>
//           <PhoneInput value={phone} onChange={setPhone} disabled={loading} invalid={!!phone && !validPhone} />
//           {!validPhone && phone && <ErrorText>Enter a valid 10-digit number.</ErrorText>}
//           <HelpText>We’ll send a 6-digit OTP to this number.</HelpText>
//           <SolidButton disabled={!validPhone || loading} onClick={send}>
//             {loading ? "Sending..." : "Send OTP"}
//           </SolidButton>
//         </>
//       ) : (
//         <>
//           <div className="text-sm text-slate-700">
//             OTP sent to <span className="font-semibold">+91 {phone}</span>
//           </div>
//           <div className="mt-3">
//             <OtpInputs value={otp} onChange={setOtp} />
//           </div>

//           <div className="mt-3 flex items-center justify-between">
//             <button
//               className="text-sm text-slate-600 hover:underline"
//               onClick={() => setStep("details")}
//             >
//               Edit number
//             </button>
//             <button
//               onClick={async () => {
//                 if (timer > 0 || loading) return;
//                 await send();
//               }}
//               disabled={timer > 0 || loading}
//               className={`text-sm font-semibold ${
//                 timer > 0 ? "text-slate-400" : "text-amber-700 hover:underline"
//               }`}
//             >
//               {timer > 0 ? `Resend in 0:${String(timer).padStart(2, "0")}` : "Resend OTP"}
//             </button>
//           </div>

//           <SolidButton disabled={otp.length !== 6 || loading} onClick={verify}>
//             {loading ? "Verifying..." : "Verify & Login"}
//           </SolidButton>
//         </>
//       )}
//     </div>
//   );
// }

// /* ====================== REGISTER (OTP) ====================== */
// function RegisterForm({ next, onDone }) {
//   const nav = useNavigate();
//   const { login } = useAuth();

//   const [form, setForm] = useState({ name: "", email: "", phone: "" });
//   const [step, setStep] = useState("details"); // details | otp
//   const [otp, setOtp] = useState("");
//   const [timer, setTimer] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const validPhone = /^\d{10}$/.test(form.phone);
//   const validEmail = !form.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
//   const canDetails = form.name.trim() && validPhone && validEmail;

//   useEffect(() => {
//     if (timer <= 0) return;
//     const t = setTimeout(() => setTimer((s) => s - 1), 1000);
//     return () => clearTimeout(t);
//   }, [timer]);

//   const onSend = async () => {
//     try {
//       setLoading(true);
//       await registerUser({ name: form.name, email: form.email, phone: form.phone });
//       setStep("otp");
//       setTimer(30);
//       toast.success("OTP sent ✔");
//     } catch (e) {
//       toast.error(e?.message || "Failed to start verification ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onVerify = async () => {
//     try {
//       setLoading(true);
//       const resp = await verifyOtp({ mobile: form.phone, code: otp });
//       const token = resp?.token || resp?.jwt || "demo_jwt_" + Date.now();
//       const profile = resp?.data || resp?.profile || resp;
//       const finalUser = {
//         id: profile?._id ?? form.phone,
//         name: profile?.name ?? form.name,
//         phone: profile?.mobile ?? form.phone,
//         role: profile?.role,
//         avatar: profile?.profileImage,
//         email: profile?.email ?? form.email,
//       };
//       login(finalUser, token);
//       toast.success("Account created 🎉");
//       onDone?.();
//       nav(next || "/", { replace: true });
//     } catch (e) {
//       toast.error(e?.message || "Verification failed ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       {step === "details" ? (
//         <>
//           <div className="grid gap-3">
//             <div>
//               <FieldLabel>Full Name</FieldLabel>
//               <input
//                 className="mt-1 w-full rounded-lg border px-3 py-2 outline-none focus:ring-2 focus:ring-amber-300"
//                 value={form.name}
//                 onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//                 placeholder="Your name"
//               />
//             </div>

//             <div>
//               <FieldLabel>Email (optional)</FieldLabel>
//               <input
//                 className={`mt-1 w-full rounded-lg border px-3 py-2 outline-none focus:ring-2 ${form.email && !validEmail ? "border-rose-300 focus:ring-rose-200" : "focus:ring-amber-300"}`}
//                 value={form.email}
//                 onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
//                 placeholder="you@example.com"
//                 autoComplete="email"
//               />
//               {form.email && !validEmail && <ErrorText>Enter a valid email.</ErrorText>}
//             </div>

//             <div>
//               <FieldLabel>Mobile Number</FieldLabel>
//               <PhoneInput
//                 value={form.phone}
//                 onChange={(v) => setForm((f) => ({ ...f, phone: v }))}
//                 disabled={loading}
//                 invalid={!!form.phone && !validPhone}
//               />
//               {!validPhone && form.phone && (
//                 <ErrorText>Enter a valid 10-digit number.</ErrorText>
//               )}
//             </div>
//           </div>

//           <SolidButton disabled={!canDetails || loading} onClick={onSend}>
//             {loading ? "Sending..." : "Send OTP"}
//           </SolidButton>
//         </>
//       ) : (
//         <>
//           <motion.div className="text-sm text-slate-700">
//             OTP sent to <span className="font-semibold">+91 {form.phone}</span>
//           </div>

//           <div className="mt-3">
//             <OtpInputs value={otp} onChange={setOtp} />
//           </div>

//           <div className="mt-3 flex items-center justify-between">
//             <button
//               className="text-sm text-slate-600 hover:underline"
//               onClick={() => setStep("details")}
//             >
//               Edit details
//             </button>
//             <button
//               onClick={async () => {
//                 if (timer > 0 || loading) return;
//                 await onSend();
//               }}
//               disabled={timer > 0 || loading}
//               className={`text-sm font-semibold ${
//                 timer > 0 ? "text-slate-400" : "text-amber-700 hover:underline"
//               }`}
//             >
//               {timer > 0 ? `Resend in 0:${String(timer).padStart(2, "0")}` : "Resend OTP"}
//             </button>
//           </div>

//           <SolidButton disabled={otp.length !== 6 || loading} onClick={onVerify}>
//             {loading ? "Verifying..." : "Verify & Create Account"}
//           </SolidButton>
//         </>
//       )}
//     </div>
//   );
// }

// /* ======================== MAIN MODAL ======================== */
// export default function AuthModal({
//   open,
//   onClose,
//   defaultTab = "login",     // 'login' | 'register'
//   next = "/",
//   logoSrc,                   // show logo at top if headerVariant="logo"
//   brandName = "BroBookShow", // fallback brand name
//   headerVariant = "logo",    // "logo" | "welcome"
// }) {
//   const [tab, setTab] = useState(defaultTab);
//   const location = useLocation();
//   const { user } = useAuth();

//   useEffect(() => setTab(defaultTab), [defaultTab]);

//   // allow ?auth=login|register
//   const urlTab = new URLSearchParams(location.search).get("auth");
//   useEffect(() => {
//     if (urlTab === "login" || urlTab === "register") setTab(urlTab);
//   }, [urlTab]);

//   const displayName = useMemo(() => {
//     const full = user?.name || user?.phone || brandName || "Guest";
//     const first = String(full).trim().split(/\s+/)[0] || full;
//     return first;
//   }, [user, brandName]);

//   return (
//     <ModalShell open={open} onClose={onClose} title="Account">
//       {/* Header strip */}
//       <div className="h-2 rounded-t-2xl bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400" />
//       <div className="p-5">
//         {/* Header (logo OR welcome) */}
//         {headerVariant === "logo" ? (
//           <div className="w-full flex items-center justify-center mb-3">
//             {logoSrc ? (
//               <img src={logoSrc} alt={brandName} className="h-20 w-auto object-contain" />
//             ) : (
//               <div className="text-lg font-extrabold">{brandName}</div>
//             )}
//           </div>
//         ) : (
//           <div className="w-full text-center mb-3">
//             <div className="text-xs uppercase tracking-wider text-slate-500">Welcome</div>
//             <div className="text-xl font-bold text-slate-900 mt-0.5">{displayName}</div>
//           </div>
//         )}

//         {/* Close button */}
//         <div className="flex items-center justify-end -mt-2 -mr-2">
//           <button
//             onClick={onClose}
//             aria-label="Close"
//             className="rounded-full p-2 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300"
//           >
//             <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//               <path d="M6 18L18 6M6 6l12 12" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//             </svg>
//           </button>
//         </div>

//         {/* Tabs */}
//         <div className="mt-2 grid grid-cols-2 rounded-full bg-slate-100 p-1">
//           {["login", "register"].map((t) => (
//             <button
//               key={t}
//               onClick={() => setTab(t)}
//               className={`py-2 rounded-full text-sm font-semibold transition-all ${
//                 tab === t ? "bg-white shadow text-slate-900" : "text-slate-600"
//               }`}
//             >
//               {t === "login" ? "Login" : "Create account"}
//             </button>
//           ))}
//         </div>

//         {/* Body */}
//         <div className="mt-4">
//           {tab === "login" ? (
//             <LoginForm next={next} onDone={onClose} />
//           ) : (
//             <RegisterForm next={next} onDone={onClose} />
//           )}
//         </div>

//         {/* Footer helper */}
//         <div className="mt-4 text-center text-[11px] text-slate-500">
//           By continuing, you agree to our{" "}
//           <a href="/terms" className="underline hover:text-slate-700">Terms</a> &{" "}
//           <a href="/privacy" className="underline hover:text-slate-700">Privacy Policy</a>.
//         </div>
//       </div>
//     </ModalShell>
//   );
// }


// src/components/AuthModal.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import OtpInputs from "../components/OtpInputs.jsx";
import { sendOtp, verifyOtp, registerUser } from "../api/auth.js";
import { isValidIndianPhoneInput, sanitizePhoneInputDigits } from "../utils/phone.js";
import { toast } from "react-toastify";

/* -----------------------------------------------------------
   Shell: accessible modal with backdrop + scale/opacity anim
----------------------------------------------------------- */
function ModalShell({ open, onClose, children, title = "Account" }) {
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [onClose]);

  return (
    <div
      aria-hidden={!open}
      className={`fixed inset-0 z-[100] ${open ? "" : "pointer-events-none"}`}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/50 transition-opacity ${open ? "opacity-100" : "opacity-0"}`}
        onClick={onClose}
      />
      {/* Dialog */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className={`absolute left-1/2 top-1/2 w-[92vw] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-amber-100/70 dark:border-slate-800 bg-white/95 dark:bg-slate-900/95 backdrop-blur shadow-2xl transition-all ${open ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }`}
      >
        {children}
      </div>
    </div>
  );
}

/* -----------------------------------------------------------
   Small UI atoms
----------------------------------------------------------- */
function FieldLabel({ children }) {
  return <label className="text-xs font-semibold text-slate-600 dark:text-slate-300 transition-colors">{children}</label>;
}
function HelpText({ children }) {
  return <p className="mt-1 text-xs text-slate-500 dark:text-slate-400 transition-colors">{children}</p>;
}
function ErrorText({ children }) {
  return <p className="mt-1 text-xs text-rose-600">{children}</p>;
}
function SolidButton({ disabled, children, onClick }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`mt-4 w-full rounded-full px-5 py-2.5 font-semibold transition-all
        ${disabled
          ? "bg-slate-200 dark:bg-slate-800 text-slate-500 dark:text-slate-400 cursor-not-allowed"
          : "bg-gradient-to-r from-amber-400 to-amber-500 text-slate-900 hover:from-amber-500 hover:to-amber-600 shadow-sm"
        }`}
    >
      {children}
    </button>
  );
}

/* -----------------------------------------------------------
   Phone input with +91 lock, validation highlight
----------------------------------------------------------- */
function PhoneInput({ value, onChange, disabled, invalid }) {
  return (
    <div className="mt-1 flex">
      <span className="inline-flex items-center rounded-l-lg border dark:border-slate-700 border-r-0 px-3 text-slate-600 dark:text-slate-300 bg-slate-50 dark:bg-slate-800 transition-colors">
        +91
      </span>
      <input
        className={`flex-1 rounded-r-lg border dark:border-slate-700 px-3 py-2 outline-none bg-white dark:bg-slate-900 text-slate-900 dark:text-white transition-colors focus:ring-2 ${invalid ? "border-rose-300 focus:ring-rose-200" : "focus:ring-amber-300"}`}
        placeholder="10-digit mobile"
        value={value}
        disabled={disabled}
        inputMode="numeric"
        autoComplete="tel"
        onChange={(e) => onChange(sanitizePhoneInputDigits(e.target.value))}
      />
    </div>
  );
}

/* ======================== LOGIN (OTP) ======================== */
function LoginForm({ next, onDone }) {
  const nav = useNavigate();
  const { login } = useAuth();

  const [phone, setPhone] = useState("");
  const [step, setStep] = useState("details"); // details | otp
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);

  const validPhone = isValidIndianPhoneInput(phone);

  useEffect(() => {
    if (timer <= 0) return;
    const t = setTimeout(() => setTimer((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [timer]);

  const send = async () => {
    try {
      setLoading(true);
      await sendOtp(phone);
      setOtp("");         // ensure fresh OTP input
      setStep("otp");
      setTimer(30);
      toast.success("OTP sent successfully ✅");
    } catch (e) {
      toast.error(e?.message || "Failed to send OTP ❌");
    } finally {
      setLoading(false);
    }
  };

  const verify = async () => {
    try {
      setLoading(true);
      const resp = await verifyOtp({ mobile: phone, code: otp });

      // ✅ Only proceed if success is true
      if (!resp?.success) {
        throw new Error(resp?.message || "OTP verification failed ❌");
      }

      const token = resp?.token || resp?.jwt;
      const profile = resp?.data || resp?.profile || resp;

      const tenDigit = profile?.mobile ?? phone;
      const finalUser = {
        id: profile?._id ?? phone,
        name: profile?.name ?? ("User " + phone.slice(-4)),
        phone: tenDigit,
        mobile: tenDigit,
        role: profile?.role,
        avatar: profile?.profileImage,
        email: profile?.email,
      };

      login(finalUser, token);
      toast.success("Logged in successfully 🎉");
      onDone?.();
      nav(next || "/", { replace: true });
    } catch (e) {
      toast.error(e?.message || "OTP verification failed ❌");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      {step === "details" ? (
        <>
          <FieldLabel>Mobile Number</FieldLabel>
          <PhoneInput value={phone} onChange={setPhone} disabled={loading} invalid={!!phone && !validPhone} />
          {!validPhone && phone && <ErrorText>Enter a valid 10-digit mobile number.</ErrorText>}
          <HelpText>We’ll send a 6-digit OTP to this number.</HelpText>
          <SolidButton disabled={!validPhone || loading} onClick={send}>
            {loading ? "Sending..." : "Send OTP"}
          </SolidButton>
        </>
      ) : (
        <>
          <div className="text-sm text-slate-700">
            OTP sent to <span className="font-semibold font-serif">+91 {phone}</span>
          </div>
          <div className="mt-3">
            <OtpInputs value={otp} onChange={setOtp} />
          </div>

          <div className="mt-3 flex items-center justify-between">
            <button
              className="text-sm text-slate-600 hover:underline"
              onClick={() => {
                setStep("details");
                setOtp("");       // reset OTP
                setTimer(0);      // stop countdown
              }}
            >
              Edit number
            </button>
            <button
              onClick={async () => {
                if (timer > 0 || loading) return;
                setOtp("");       // clear old OTP before re-sending
                await send();
              }}
              disabled={timer > 0 || loading}
              className={`text-sm font-semibold ${timer > 0 ? "text-slate-400" : "text-amber-700 hover:underline"
                }`}
            >
              {timer > 0 ? `Resend in 0:${String(timer).padStart(2, "0")}` : "Resend OTP"}
            </button>
          </div>

          <SolidButton disabled={otp.length !== 6 || loading} onClick={verify}>
            {loading ? "Verifying..." : "Verify & Login"}
          </SolidButton>
        </>
      )}
    </div>
  );
}

/* ====================== REGISTER (OTP) ====================== */
function RegisterForm({ next, onDone }) {
  const nav = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [step, setStep] = useState("details"); // details | otp
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);

  const validPhone = isValidIndianPhoneInput(form.phone);
  const validEmail = !form.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
  const canDetails = form.name.trim() && validPhone && validEmail;

  useEffect(() => {
    if (timer <= 0) return;
    const t = setTimeout(() => setTimer((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [timer]);

  const onSend = async () => {
    try {
      setLoading(true);
      await registerUser({ name: form.name, email: form.email, phone: form.phone });
      setOtp("");        // ensure fresh OTP input
      setStep("otp");
      setTimer(30);
      toast.success("OTP sent ✔");
    } catch (e) {
      toast.error(e?.message || "Failed to start verification ❌");
    } finally {
      setLoading(false);
    }
  };

  const onVerify = async () => {
    try {
      setLoading(true);
      const resp = await verifyOtp({ mobile: form.phone, code: otp });
      const token = resp?.token || resp?.jwt;
      const profile = resp?.data || resp?.profile || resp;
      const tenDigit = profile?.mobile ?? form.phone;
      const finalUser = {
        id: profile?._id ?? form.phone,
        name: profile?.name ?? form.name,
        phone: tenDigit,
        mobile: tenDigit,
        role: profile?.role,
        avatar: profile?.profileImage,
        email: profile?.email ?? form.email,
      };
      login(finalUser, token);
      toast.success("Account created 🎉");
      onDone?.();
      nav(next || "/", { replace: true });
    } catch (e) {
      toast.error(e?.message || "Verification failed ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {step === "details" ? (
        <>
          <div className="grid gap-3">
            <div>
              <FieldLabel>Full Name</FieldLabel>
              <input
                className="mt-1 w-full rounded-lg border px-3 py-2 outline-none focus:ring-2 focus:ring-amber-300"
                value={form.name}
                onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                placeholder="Your name"
              />
            </div>

            <div>
              <FieldLabel>Email (optional)</FieldLabel>
              <input
                className={`mt-1 w-full rounded-lg border px-3 py-2 outline-none focus:ring-2 ${form.email && !validEmail ? "border-rose-300 focus:ring-rose-200" : "focus:ring-amber-300"}`}
                value={form.email}
                onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                placeholder="you@example.com"
                autoComplete="email"
              />
              {form.email && !validEmail && <ErrorText>Enter a valid email.</ErrorText>}
            </div>

            <div>
              <FieldLabel>Mobile Number</FieldLabel>
              <PhoneInput
                value={form.phone}
                onChange={(v) => setForm((f) => ({ ...f, phone: v }))}
                disabled={loading}
                invalid={!!form.phone && !validPhone}
              />
              {!validPhone && form.phone && (
                <ErrorText>Enter a valid 10-digit mobile number.</ErrorText>
              )}
            </div>
          </div>

          <SolidButton disabled={!canDetails || loading} onClick={onSend}>
            {loading ? "Sending..." : "Send OTP"}
          </SolidButton>
        </>
      ) : (
        <>
          <div className="text-sm text-slate-700">
            OTP sent to <span className="font-semibold font-serif">+91 {form.phone}</span>
          </div>

          <div className="mt-3 font-serif">
            <OtpInputs value={otp} onChange={setOtp} />
          </div>

          <div className="mt-3 flex items-center justify-between font-serif">
            <button
              className="text-sm text-slate-600 hover:underline"
              onClick={() => {
                setStep("details");
                setOtp("");       // reset OTP
                setTimer(0);      // stop countdown
              }}
            >
              Edit details
            </button>
            <button
              onClick={async () => {
                if (timer > 0 || loading) return;
                setOtp("");       // clear old OTP before re-sending
                await onSend();
              }}
              disabled={timer > 0 || loading}
              className={`text-sm font-semibold ${timer > 0 ? "text-slate-400" : "text-amber-700 hover:underline"
                }`}
            >
              {timer > 0 ? `Resend in 0:${String(timer).padStart(2, "0")}` : "Resend OTP"}
            </button>
          </div>

          {/* <SolidButton disabled={otp.length !== 6 || loading} onClick={onVerify}>
            {loading ? "Verifying..." : "Verify & Create Account"}
          </SolidButton> */}
        </>
      )}
    </div>
  );
}

/* ======================== MAIN MODAL ======================== */
export default function AuthModal({
  open,
  onClose,
  defaultTab = "login",     // 'login' | 'register'
  next = "/",
  logoSrc,                   // show logo at top if headerVariant="logo"
  brandName = "ShowTimeBro", // fallback brand name
  headerVariant = "logo",    // "logo" | "welcome"
}) {
  const [tab, setTab] = useState(defaultTab);
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => setTab(defaultTab), [defaultTab]);

  // allow ?auth=login|register
  const urlTab = new URLSearchParams(location.search).get("auth");
  useEffect(() => {
    if (urlTab === "login" || urlTab === "register") setTab(urlTab);
  }, [urlTab]);

  const displayName = useMemo(() => {
    const full = user?.name || user?.phone || brandName || "Guest";
    const first = String(full).trim().split(/\s+/)[0] || full;
    return first;
  }, [user, brandName]);

  return (
   <ModalShell open={open} onClose={onClose} title="Account">
  {/* Header strip */}
  <div className="h-2 rounded-t-2xl bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400" />

  <div className="p-5 font-serif flex flex-col items-center text-center">
    {/* Header (logo OR welcome) */}
    {headerVariant === "logo" ? (
      <div className="flex items-center justify-center mb-3">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={brandName}
            className="h-20 w-auto object-contain"
          />
        ) : (
          <div className="text-lg font-extrabold">{brandName}</div>
        )}
      </div>
    ) : (
      <div className="mb-3">
        <div className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400 transition-colors">
          Welcome
        </div>
        <div className="text-xl font-bold text-slate-900 dark:text-white mt-0.5 transition-colors">
          {displayName}
        </div>
      </div>
    )}

    {/* Close button (top-right) */}
    <div className="absolute top-4 right-4">
      <button
        onClick={onClose}
        aria-label="Close"
        className="rounded-full p-2 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-900 dark:text-slate-300 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300"
      >
        <svg
          className="h-5 w-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            d="M6 18L18 6M6 6l12 12"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>

    {/* Login button centered */}
    <div className="mt-2 flex justify-center">
      <button className="w-40 py-2 rounded-full text-sm font-semibold bg-white dark:bg-slate-800 shadow text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
        Login
      </button>
    </div>

    {/* Body (centered) */}
    <div className="mt-4 w-full flex justify-center">
      <div className="w-full max-w-xs">
        {tab === "login" ? (
          <LoginForm key={`login-${open}-${tab}`} next={next} onDone={onClose} />
        ) : (
          <RegisterForm
            key={`register-${open}-${tab}`}
            next={next}
            onDone={onClose}
          />
        )}
      </div>
    </div>

    {/* Footer */}
    <div className="mt-4 text-center text-[11px] text-slate-500 dark:text-slate-400 max-w-xs transition-colors">
      By continuing, you agree to our{" "}
      <a href="/terms" className="underline hover:text-slate-700 dark:hover:text-slate-300 transition-colors">
        Terms
      </a>{" "}
      &{" "}
      <a href="/privacy" className="underline hover:text-slate-700 dark:hover:text-slate-300 transition-colors">
        Privacy Policy
      </a>.
    </div>
  </div>
</ModalShell>

  );
}
